export interface AlbumUpdateBody {
    albumUUIDs: string[];
    entityUUIDs?: string[];
    entityUUIDsMode?: 'exclusive' | 'inclusive';
    entityFilter?: { [p: string]: string };
  }